import { ArticleType, AssetType, OnboardingType } from '@nemuru-eng/js-api-client';

import { ICON_NAMES } from '@/config/config';

export const getIconByAssetOrArticleType = (
  type: AssetType | ArticleType | null | undefined,
  onboardingType?: OnboardingType,
) => {
  switch (type) {
    case AssetType.ORDER:
      return ICON_NAMES.ORDER;
    case AssetType.CREDIT_LINE:
      return ICON_NAMES.CREDIT_LINE;
    case AssetType.EDUCATION:
      return ICON_NAMES.EDUCATION;
    case AssetType.HEALTH:
      return ICON_NAMES.HEALTH;
    case AssetType.AUTO:
      return onboardingType === OnboardingType.NATURAL_PERSON ? ICON_NAMES.AUTO : 'emoji_transportation';
    case AssetType.HOME_IMPROVEMENT:
      return ICON_NAMES.HOME_IMPROVEMENT;
    case AssetType.TRAVEL:
      return ICON_NAMES.TRAVEL;
    case AssetType.UTILITIES_SUPPLY:
      return ICON_NAMES.UTILITIES_SUPPLY;
    case AssetType.OTHER:
      return ICON_NAMES.OTHER;
    case ArticleType.FLIGHT:
      return ICON_NAMES.FLIGHT_SMALL;
    case ArticleType.ACCOMMODATION:
      return ICON_NAMES.ACCOMMODATION;
    case ArticleType.ONLINE_PRODUCT:
      return ICON_NAMES.PRODUCT;
    case ArticleType.SERVICE:
      return ICON_NAMES.SERVICE;
    default:
      return ICON_NAMES.ORDER;
  }
};
